import { Theme, ThemeConsumer } from '@rneui/themed';
import React, { useState } from 'react';
import {
	View,
	TouchableOpacity,
	StyleSheet,
	TextInput,
	Keyboard,
	Pressable,
	FlatList,
	Text,
	useWindowDimensions
} from 'react-native';
import { ZenBadge, ZenIcon, ZenLoader, ZenText, ZenToast } from 'zen-core-elements';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { addCustomer, addParkSale, clearCart, retriveSale } from '../../../redux/slices/newSellscreenSlice';
import { CustomModal } from '../../../shared/commonComponents/customModal';
import { initialStateType } from '../../../redux/types/sellScreenTypes';
import moment from 'moment';
import { setCurrentLocation } from '../../../redux/slices/commonSlice';
import Popover from 'react-native-popover-view';
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox';
import { appColors } from '../../../themes/appTheme';
import { config } from '../../../shared/environment';
import { updateOrderDetails, updateOrderPayload } from '../../../redux/slices/orderSlice';

export default function ParkAndRetrieveSale({ isWrite }: { isWrite: boolean }) {
	const { width } = useWindowDimensions()
	const { cartProducts, parkSale, customerDetails, sellScreenType, returnRequestData, returnRequestWholeOrderData } = useAppSelector((state) => state.NewSellscreenSlice)
	const { id: locationId, name, timeZone } = useAppSelector((state) => state?.common?.currentLocation)
	const { loading: updateOrderDetailsLoading } = useAppSelector(state => state?.orderSlice?.updateOrderDetails)
	const { value: singleOrderDetails } = useAppSelector(state => state?.orderDetails?.getAllDetails)
	const dispatch = useAppDispatch()
	const [saleType, setSaleType] = useState<"Park" | "Retrieve">()
	const [tempNote, setTempNote] = useState('');
	const [modalVisible, setModalVisible] = useState(false);
	const [parkSalePopover, setParksalePopover] = useState(false)
	const parkSaleDialog = {
		content: 'You already have products in your cart. Please park the sale before retrieving another sale, or continue.',
		button: [{ id: 1, name: "Park Sale" }, { id: 2, name: "Continue" }],
		icon: {
			name: 'alert-outline', size: 55, color: appColors.warning, type: 'material-community'
		}
	}

	const [selectedSale, setSelectedSale] = useState<initialStateType["parkSale"][0] | null>(null)
	const orderStatusName = useAppSelector(state => state?.orderDetails?.getAllDetails?.value?.getOrderDetails?.ordersDetails?.orderStatusName)

	const handleSave = async () => {
		if (sellScreenType === "SELL") {
			dispatch(addParkSale({
				location: { id: locationId, name, timeZone },
				name: tempNote,
				customerDetails: customerDetails
			}))
		} else {
			const matchedData = singleOrderDetails?.getOrderDetails?.ordersDetails?.returnRequestStatus?.find(returnStatus => returnStatus?.code === "PENDING")
			const data: updateOrderPayload = {
				customizedOrderId: returnRequestData?.customizedOrderId!,
				event: "statusChange",
				isPreOrder: false,
				modifiedAt: new Date(),
				orderId: returnRequestData?.orderId!,
				orderName: matchedData?.value!,
				orderStatus: matchedData?.id!,
				orderStatusCode: matchedData?.code!,
				orderStatusDate: new Date(),
				storeId: config.storeId,
				todayDate: moment(new Date()).format('MMMM D, YYYY - h:mm A'),
				userEmail: customerDetails?.email!
			}
			await dispatch(updateOrderDetails({ data, storeId: config.storeId, orderId: returnRequestData?.orderId })).unwrap().then((updateReturnProductRes) => {
				if (updateReturnProductRes?.success) {
					ZenToast({ message: "Return Parked Successfully", type: "success" })
					dispatch(clearCart())
					dispatch(addCustomer({
						customerDetails: {
							details: null, locationId: config?.storeId
						}
					}))
				}
			})
		}
		setTempNote("")
		setModalVisible(false);
	};

	const handleParkSale = () => {
		if (!customerDetails) {
			ZenToast({ type: "warning", message: "You can not park sale without customer" })
			return
		}
		if (!isWrite) {
			ZenToast({ message: "You don't have access!", type: "warning" })
			return
		}
		if (customerDetails?.firstName) {
			setTempNote(customerDetails?.firstName + (sellScreenType === "SELL" ? "'s Sale" : "'s Return"))
		}
		setSaleType("Park")
		setModalVisible(true)
	}

	const handleRetrieve = () => {
		if (selectedSale?.location?.id !== locationId) {
			dispatch(setCurrentLocation(selectedSale?.location!!))
		}
		dispatch(retriveSale(selectedSale!!))
		setModalVisible(false);
		setTempNote("")
		setSelectedSale(null)
	}

	const openRetrieveModal = () => {
		setSaleType("Retrieve")
		setModalVisible(true)
	}

	const retriveSaleCheck = () => {
		if (!isWrite) {
			ZenToast({ message: "You don't have access!", type: "warning" })
			return
		}
		if (cartProducts[locationId]?.length) {
			setParksalePopover(true)
		} else {
			openRetrieveModal()
		}
	}

	const parksaleConfirmation = (item: { id: number }) => {
		setParksalePopover(false)
		if (item?.id == 1) {
			handleParkSale()
		} else {
			openRetrieveModal()
		}
	}

	const renderItem = ({ item }: { item: initialStateType["parkSale"][0] }) => {
		const isSelected = selectedSale?.id === item.id
		const parkLocationId = item?.location?.id

		return (
			<ThemeConsumer>
				{({ theme }) => {
					const styles = style(theme)
					return (
						(
							<TouchableOpacity
								activeOpacity={0.7}
								onPress={() => { setSelectedSale(item) }}
								style={[
									styles.card,
									isSelected && styles.cardSelected,
								]}
							>
								{/* Left Icon */}
								<View style={[styles.iconContainer, isSelected && styles.iconContainerSelected]}>
									<ZenIcon
										name='sale'
										type='material-community'
										size={20}
										color={isSelected ? theme?.light : theme?.lightGrey}
									/>
								</View>

								{/* Text Content */}
								<View style={styles.textContainer}>
									<ZenText content={item.name || "Guest" + " ( Total Products: " + item.details.cartProducts?.[parkLocationId]?.length +
										" | Total Quantity: " + item.details.cartQuantity[parkLocationId] +
										" | Total Price: " + item.details.summary?.[parkLocationId]?.grandTotal +
										" )"} style={[styles.locationName, isSelected && styles.textSelected]} />
									<ZenText content={item.date?.toDateString() + " " + moment(item.date).format("LT")} style={[styles.locationAddress, isSelected && styles.textSelected]} numberOfLines={1} />
									<ZenText content={"Location: " + item.location.name} style={[styles.locationAddress, isSelected && styles.textSelected]} numberOfLines={1} />
								</View>

								{/* Right Indicator (Radio/Check) */}
								<View style={[styles.radio, isSelected && styles.radioSelected]}>
									{isSelected && <ZenIcon name="check" type='feather' size={14} color={theme?.light} />}
								</View>
							</TouchableOpacity>
						)
					)
				}}
			</ThemeConsumer>
		)
	};

	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<View style={styles.tabs}>
						{orderStatusName !== "Pending" && sellScreenType === "SELL" && <TouchableOpacity disabled={!cartProducts[locationId]?.length} style={[styles.parkTab, !cartProducts[locationId]?.length && styles.disabledTab]}
							onPress={handleParkSale}>
							<ZenText content={sellScreenType === "SELL" ? "Park Sale" : "Park Return"} style={[styles.parkText, !cartProducts[locationId]?.length && styles.disabledText]} />
						</TouchableOpacity>}
						{sellScreenType === "SELL" && <TouchableOpacity disabled={!parkSale?.length} style={[styles.retrieveTab, !parkSale?.length && styles.disabledTab]}
							onPress={retriveSaleCheck}>
							{parkSale?.length ? <ZenBadge
								badgeName={parkSale?.length?.toString()}
								badgeColor={theme?.tealGreen}
								badgeTextColor={theme.lightTealGreen}
								badgeTextSize={"small"}
								badgeContainerStyle={{ position: "absolute", right: -7, top: -7, height: 20, width: 20, paddingHorizontal: 0 }}
							/> : null}
							<ZenText content={"Retrieving Sale"} style={[styles.retrieveText, !parkSale?.length && styles.disabledText]} />
						</TouchableOpacity>}
						<CustomModal keyboardView visible={modalVisible} transparent animationType="fade"
							onRequestClose={() => setModalVisible(false)}>
							<TouchableOpacity
								style={styles.modalOverlay}
								activeOpacity={1}
								onPress={() => Keyboard.dismiss()}
							>
								<Pressable style={StyleSheet.absoluteFill} onPress={() => setModalVisible(false)} />
								{saleType === "Park" ? <View style={[styles.modalContent, width < 600 && { width: "100%" }]}>
									<ZenText content={sellScreenType === "SELL" ? "Sale Notes" : "Return Notes"} style={styles.modalTitle} />
									<TextInput
										style={styles.inputBox}
										placeholder={`Enter a ${sellScreenType === "SELL" ? "sale" : "return"} notes or customer name`}
										placeholderTextColor={theme?.grey}
										value={tempNote}
										onChangeText={setTempNote}
										multiline
										autoFocus
									/>
									<View style={styles.modalActions}>
										<TouchableOpacity onPress={() => setModalVisible(false)} style={styles.cancelBtn}>
											<ZenText content={"Cancel"} style={styles.cancelText} />
										</TouchableOpacity>
										<TouchableOpacity onPress={handleSave} style={styles.saveBtn}>
											{updateOrderDetailsLoading ? <ZenLoader size={"small"} color={theme?.light} /> : <ZenText content={sellScreenType === "SELL" ? "Save Sale" : "Park Return"} style={styles.saveText} />}
										</TouchableOpacity>
									</View>
								</View> :
									<View style={[styles.modalContent, width < 600 && { width: "100%" }]}>
										<ZenText content={"Select Sale"} style={styles.title} />
										<FlatList
											data={parkSale}
											renderItem={renderItem}
											keyExtractor={(_, index) => index.toString()}
											contentContainerStyle={styles.listContent}
											showsVerticalScrollIndicator={false}
											ItemSeparatorComponent={() => <View style={{ height: 12 }} />}
										/>
										<View style={styles.modalActions}>
											<TouchableOpacity onPress={() => setModalVisible(false)} style={styles.cancelBtn}>
												<ZenText content={"Cancel"} style={styles.cancelText} />
											</TouchableOpacity>
											<TouchableOpacity disabled={!selectedSale} onPress={handleRetrieve} style={[styles.saveBtn, !selectedSale && { backgroundColor: theme?.disableGray }]}>
												<ZenText content={"Proceed"} style={[styles.saveText, !selectedSale && { color: theme?.disableTextColor }]} />
											</TouchableOpacity>
										</View>
									</View>
								}
							</TouchableOpacity>
						</CustomModal>
						{/* For park sale confirmation */}
						<Popover isVisible={parkSalePopover} popoverStyle={{ width: width > 600 ? 400 : 300, borderRadius: 10, zIndex: 10 }}>
							<CommonDialogBox type="OTHER" dialog={parkSaleDialog} confirmation={parksaleConfirmation} />
						</Popover>
					</View>
				)
			}}
		</ThemeConsumer>
	);
}

const style = (theme: Theme) => (
	StyleSheet.create({

		tabs: { flexDirection: 'row', gap: 8 },
		parkTab: { paddingVertical: 8, paddingHorizontal: 16, borderRadius: 8, borderWidth: 1, borderColor: theme?.goldenOrange, backgroundColor: theme?.warmCream, justifyContent: "center" },
		parkText: { color: theme?.goldenOrange, fontFamily: theme?.medium, fontSize: theme?.errorFontSize },
		disabledTab: { backgroundColor: theme?.disableGray, borderWidth: 0 },
		disabledText: { color: theme?.disabledGray500 },
		retrieveTab: { paddingVertical: 8, paddingHorizontal: 16, borderRadius: 8, backgroundColor: theme?.lightTealGreen, justifyContent: "center", borderWidth: 1, borderColor: theme?.tealGreen },
		retrieveText: { color: theme?.tealGreen, fontFamily: theme?.medium, fontSize: theme?.errorFontSize },
		modalOverlay: {
			flex: 1,
			backgroundColor: theme?.modalBg100,
			justifyContent: 'center',
			alignItems: "center",
			padding: 20,
		},
		modalContent: {
			width: "60%",
			backgroundColor: theme?.light,
			borderRadius: 16,
			padding: 20,
		},
		modalTitle: { fontSize: theme?.smallerFontSize, fontFamily: theme?.bold, marginBottom: 12 },
		listContent: {
			paddingBottom: 20,
			flexGrow: 1
		},
		inputBox: {
			backgroundColor: theme?.softSlate,
			borderRadius: 8,
			padding: 12,
			height: 100,
			textAlignVertical: 'top',
			fontSize: theme?.smallHeaderFontSize,
			color: theme?.lightDark,
			fontFamily: theme?.medium,
			marginBottom: 16,
		},
		modalActions: { flexDirection: 'row', justifyContent: 'flex-end', gap: 12 },
		cancelBtn: { padding: 10 },
		cancelText: { color: theme?.grey, fontFamily: theme?.medium, fontSize: theme?.errorFontSize },
		saveBtn: { backgroundColor: theme?.primary, paddingHorizontal: 20, paddingVertical: 10, borderRadius: 8 },
		saveText: { color: theme?.light, fontFamily: theme?.bold, fontSize: theme?.errorFontSize },

		title: {
			fontSize: theme?.smallerFontSize,
			fontFamily: theme?.bold,
			color: theme?.lightDark,
			marginBottom: 12,
		},

		card: {
			flexDirection: 'row',
			alignItems: 'center',
			padding: 16,
			borderRadius: 16,
			backgroundColor: theme?.light,
			borderWidth: 1.5,
			borderColor: theme?.coolGray,
		},
		cardSelected: {
			borderColor: theme?.draggerIcon,
			backgroundColor: theme?.blue50,
		},
		iconContainer: {
			width: 40,
			height: 40,
			borderRadius: 20,
			backgroundColor: theme?.softSlate,
			justifyContent: 'center',
			alignItems: 'center',
			marginRight: 16,
		},
		iconContainerSelected: {
			backgroundColor: theme?.draggerIcon,
		},
		textContainer: {
			flex: 1,
		},
		locationName: {
			fontSize: theme?.smallFontSize,
			fontFamily: theme?.medium,
			color: theme?.lightDark,
			marginBottom: 2,
		},
		textSelected: {
			fontFamily: theme?.bold,
			color: theme?.lightDark,
		},
		locationAddress: {
			fontSize: theme?.miniFontSize,
			fontFamily: theme?.medium,
			color: theme?.grey,
		},


		radio: {
			width: 24,
			height: 24,
			borderRadius: 12,
			borderWidth: 2,
			borderColor: theme?.coolGray,
			justifyContent: 'center',
			alignItems: 'center',
		},
		radioSelected: {
			borderColor: theme?.tealGreen,
			backgroundColor: theme?.tealGreen,
		},
	})
)